import React, { useState } from 'react';
import { TextField, Button, Box } from '@mui/material';

const FacturacionForm = ({ onSubmit, initialData = {} }) => {
    const [formData, setFormData] = useState({
        identification_document_id: initialData.identification_document_id || 3,
        identification: initialData.identification || '',
        dv: initialData.dv || '',
        company: initialData.company || '',
        trade_name: initialData.trade_name || '',
        names: initialData.names || '',
        address: initialData.address || '',
        email: initialData.email || '',
        phone: initialData.phone || '',
        legal_organization_id: initialData.legal_organization_id || 2,
        tribute_id: initialData.tribute_id || 21,
        municipality_id: initialData.municipality_id || 980,
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <TextField
                name="names"
                label="Nombres y Apellidos"
                value={formData.names}
                onChange={handleChange}
                fullWidth
                required
                sx={{ mb: 2 }}
            />
            <TextField
                name="identification"
                label="Número de Identificación"
                value={formData.identification}
                onChange={handleChange}
                fullWidth
                required
                sx={{ mb: 2 }}
            />
            <TextField
                name="address"
                label="Dirección"
                value={formData.address}
                onChange={handleChange}
                fullWidth
                required
                sx={{ mb: 2 }}
            />
            <TextField
                name="email"
                label="Correo Electrónico"
                type="email"
                value={formData.email}
                onChange={handleChange}
                fullWidth
                required
                sx={{ mb: 2 }}
            />
            <TextField
                name="phone"
                label="Teléfono"
                value={formData.phone}
                onChange={handleChange}
                fullWidth
                required
                sx={{ mb: 2 }}
            />
            <Button type="submit" variant="contained" color="primary">
                Guardar Datos
            </Button>
        </Box>
    );
};

export default FacturacionForm;